import Button from '../../sharedComponents/Button/Button';
import Heading from '../../sharedComponents/Heading/Heading';
import './ProductsPage.scss';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import ProductImage from '../../../assets/Dashboard.svg';
import ProductsFeature from '../../../assets/ProductsImage.svg';
import ProductImage4 from '../../../assets/ProductsImage4.svg';
import tick from '../../../assets/icons/tick.svg'
import Accordion from '../../sharedComponents/Accordian/Accordian';
import { useEffect, useRef } from 'react';
import ScrollCarousel from 'scroll-carousel';
import containersIcon from '../../../assets/icons/containers.svg';
import levelsIcon from '../../../assets/icons/levels.svg';
import dollarIcon from '../../../assets/icons/dollar.svg';
import { useNavigate } from 'react-router-dom';
import bolt from '../../../assets/icons/bolt.svg';
import rocket from '../../../assets/icons/rocketNew.svg';
import personPlay from '../../../assets/icons/personPlay.svg';
import stacks from '../../../assets/icons/stacks.svg';

function ProductsPage() {
    const carouselRefTwo = useRef(null);

    const navigate = useNavigate();

    const goToContactUs = () => {
        window.scrollTo(0, 0);
        navigate("/contact");
    }

    const goToProductsSection = () => {
        const element = document.getElementById('product-content');

        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: y,
                behavior: 'smooth',
            });
        }
    }

    useEffect(() => {
        if (carouselRefTwo.current) {
            const carouselTwo = new ScrollCarousel(".my-carousel-two", {
                speed: 15,
                autoplay: true,
                autoplaySpeed: 5,
                smartSpeed: true,
                slideSelector: ".items-two",
                direction: "rtl",
                margin: 10
            });

            return () => {
                if (carouselTwo && typeof carouselTwo.destroy === 'function') {
                    carouselTwo.destroy();
                }
            };
        }
    }, []);
    const carouselS4Items = [
        {
            id: 1,
            title: 'Automating repetitive business operations',
            content: 'Automatically calculate wages, deductions, and taxes with precision management.',
            icon: dollarIcon
        },
        {
            id: 2,
            title: 'Enhancing productivity with intelligent AI assistants.',
            content: 'Gain actionable insights into your workforce with our real-time HR analytics.',
            icon: levelsIcon
        },
        {
            id: 2,
            title: 'Reducing human workload through smart task execution',
            content: 'Employees can easily access their personal HR data without needing to go through HR.',
            icon: containersIcon
        },
    ]
    const faqItems = [
        {
            title: "How reliable is Atom’s search functionality?",
            content: "Atom leverages enterprise-grade infrastructure with high availability and near real-time indexing to ensure consistent, reliable access to your data across all supported sources."
        },
        {
            title: "How does Atom ensure data safety and user privacy?",
            content: "Atom adheres to industry-standard security protocols, including encryption in transit and at rest, and role-based access controls to ensure user data remains private and secure. Atom also integrates with your company’s existing authentication systems (e.g., SSO, OAuth) and never stores sensitive data outside your infrastructure."
        },
        {
            title: "What data sources does Atom support?",
            content: "Atom supports a wide range of developer-focused tools including GitHub, GitLab, Bitbucket, Jira, Confluence, Google Drive, and is actively expanding integrations based on user demand."
        },
        {
            title: "Does Atom support both cloud and on-premise data sources?",
            content: "Atom primarily supports cloud-based tools, but support for on-premise deployments is available through custom integration."
        },
        {
            title: "What interfaces are available for using Atom?",
            content: "Atom is currently only available as a web app, with plans to expand to plugins and native integrations in future releases."
        },
        {
            title: "How often does Atom sync data from connected sources?",
            content: "Atom offers near real-time syncing for most integrations and allows configurable sync intervals for critical data sources"
        },
    ];
    const getProductFeature = (text: string) => {
        return (
            <div className='product-feature'>
                <img src={tick} alt={text} />
                <Heading theme='dark' size='h7' type='tertiary'>
                    {text}
                </Heading>

            </div>
        )
    }
    return (
        <div id='alpha-perceptron-products-page' className='alpha-perceptron-products-page'>
            <div className='alpha-perceptron-products-page__section-one'>
                <Heading theme='dark' size='H1' type='primary'>
                    Empowering Businesses with AI-Driven Intelligence
                </Heading>
                <Heading theme='dark' size='h6' type='tertiary'>
                    Discover cutting-edge AI tools designed to revolutionize the way enterprises access
                    and automate information
                </Heading>
                <div className='alpha-perceptron-products-page__section-one__line' />
                <Button onClick={goToProductsSection} type='blue' size='medium' icon={<ArrowForward />} >Explore our Products</Button>
            </div>
            <div className='alpha-perceptron-products-page__section-two' >
                <img className='alpha-perceptron-products-page__section-two__product-image' src={ProductImage} alt='Products' />
            </div>
            <div className='alpha-perceptron-products-page__section-three' id='product-content'>
                <div className='alpha-perceptron-products-page__section-three__text-container'>
                    <Heading size='h1' theme='dark'>
                        Atom
                    </Heading>
                    <Heading size='h3' theme='dark'>
                        AI-Powered Enterprise Search
                    </Heading>
                    <Heading theme='dark' size='h6' type='tertiary'>
                        Atom transforms how businesses access their knowledge. With natural language search,
                        employees can instantly retrieve critical information from across their organization
                    </Heading>
                    <Button type='blue' size='small' icon={<ArrowForward />} >
                        See ATOM in action
                    </Button>
                </div>
                <div className='alpha-perceptron-products-page__section-three__cards-container'>
                    <div className='alpha-perceptron-products-page__section-three__cards-container__top'>
                        <div className='alpha-perceptron-products-page__section-three__cards-container__card'>
                            <div className='content'>
                                <div className='alpha-perceptron-products-page__section-three__cards-container__card__header'>
                                    <img src={rocket} alt='AlphaPerceptron' className='card-icon' />
                                    <Heading size='h6' type='primary' theme='dark'>Productivity Accelerator</Heading>
                                </div>
                                <Heading size='h7' type='secondary' theme='dark' className='italics'>From Information Overload to Insight Overflow</Heading>
                                <Heading size='h7' type='primary' theme='dark'>
                                    Wasting hours searching across tools and recreating existing work?
                                </Heading>
                                <Heading size='h7' type='tertiary' theme='dark'>
                                    Atom's AI-powered search connects all your knowledge sources, from GitHub to Confluence. It delivers precise, contextual results in seconds—turning chaos into clarity.
                                </Heading>
                            </div>
                        </div>
                        <div className='alpha-perceptron-products-page__section-three__cards-container__card'>
                            <div className='content'>
                                <div className='alpha-perceptron-products-page__section-three__cards-container__card__header'>
                                    <img src={stacks} alt='AlphaPerceptron' className='card-icon' />
                                    <Heading size='h6' type='primary' theme='dark'>Knowledge Network</Heading>
                                </div>
                                <Heading size='h7' type='secondary' theme='dark' className='italics'>
                                    Breaking Down Walls While Respecting Boundaries
                                </Heading>
                                <Heading size='h7' type='primary' theme='dark'>
                                    Is critical knowledge locked in silos or lost with departures?
                                </Heading>
                                <Heading size='h7' type='tertiary' theme='dark'>
                                    Atom builds a secure knowledge graph across departments and tools. It enables smart discovery while enforcing access control based on roles and teams.
                                </Heading>
                            </div>


                        </div>
                    </div>
                    <div className='alpha-perceptron-products-page__section-three__cards-container__bottom'>
                        <div className='alpha-perceptron-products-page__section-three__cards-container__card'>
                            <div className='content'>
                                <div className='alpha-perceptron-products-page__section-three__cards-container__card__header'>
                                    <img src={personPlay} alt='AlphaPerceptron' className='card-icon' />
                                    <Heading size='h6' type='primary' theme='dark'>Seamless Talent Integration</Heading>
                                </div>
                                <Heading size='h7' type='secondary' theme='dark' className='italics'>Day One Expertise, Zero Knowledge Loss</Heading>
                                <Heading size='h7' type='primary' theme='dark'>
                                    Are new hires lost and outgoing experts taking knowledge with them?
                                </Heading>
                                <Heading size='h7' type='tertiary' theme='dark'>
                                    Atom accelerates onboarding with tailored knowledge paths and historical context. It also preserves key contributions from departing team members automatically.
                                </Heading>
                            </div>
                        </div>
                        <div className='alpha-perceptron-products-page__section-three__cards-container__card'>
                            <div className='content'>
                                <div className='alpha-perceptron-products-page__section-three__cards-container__card__header'>
                                    <img src={bolt} alt='AlphaPerceptron' className='card-icon' />
                                    <Heading size='h6' type='primary' theme='dark'>Resolution Revolution</Heading>
                                </div>
                                <Heading size='h7' type='secondary' theme='dark' className='italics'>From Endless Threads to Instant Answers</Heading>
                                <Heading size='h7' type='primary' theme='dark'>
                                    Are small issues turning into day-long investigations?
                                </Heading>
                                <Heading size='h7' type='tertiary' theme='dark'>
                                    Atom links errors, code changes, and past resolutions into a single view. It empowers teams to resolve issues quickly—without meetings or guesswork.
                                </Heading>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className='flexBox'>
                <img className='atom-image' src={ProductsFeature} alt='Atom' />
                <div className='flexBox__points'>
                    {getProductFeature('Advanced natural language understanding')}
                    {getProductFeature('Secure and permission-aware access')}
                    {getProductFeature('Fast, accurate, and context-aware results.')}
                </div>
            </div>
            <div className='alpha-perceptron-products-page__section-four'>
                <div className='alpha-perceptron-products-page__section-four__text-container'>
                    <Heading size='h2' theme='dark'>
                        Atom Agents
                    </Heading>
                    <Heading size='h4' theme='dark'>
                        Intelligent Workflow Automation
                    </Heading>
                    <Heading theme='dark' size='h6' type='tertiary'>
                        Atom Agents go beyond search—automating workflows, executing tasks, and optimizing
                        business processes autonomously
                    </Heading>
                    <Button type='blue' size='small' icon={<ArrowForward />} >
                        Try Atom Agents
                    </Button>
                </div>
                <div className='alpha-perceptron-products-page__section-four__carousel-container'>
                    <div className="my-carousel-two" ref={carouselRefTwo}>
                        {carouselS4Items.map(item => (
                            <div className='alpha-perceptron-products-page__section-four__carousel-container__carousel-item items-two'>
                                <div className='alpha-perceptron-products-page__section-four__carousel-container__carousel-item__icon'>
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <Heading size='h6' theme='dark'>{item.title}</Heading>
                                <Heading size='h7' theme='dark' type='tertiary'>{item.content}</Heading>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='alpha-perceptron-products-page__section-six'>
                <Heading size='h2' theme='dark'>
                    Get Started with Our AI Solutions
                </Heading>
                <Heading size='h6' type='tertiary' theme='dark'>
                    "Ready to revolutionize how your business interacts with data? Contact us to explore how Alpha
                    Perceptron's AI can transform your organization"
                </Heading>
                <Button onClick={goToContactUs} type='blue' size='small' icon={<ArrowForward />} >
                    Request a Demo
                </Button>
                <img src={ProductImage4} alt='AlphaPerceptron' />
            </div>
            <div className='alpha-perceptron-products-page__section-seven'>
                <Heading size='h2' theme='dark'>
                    Frequently asked questions
                </Heading>
                <Heading size='h6' type='tertiary' theme='dark'>
                    Still have more questions? Don’t hesitate to contact us!
                </Heading>
                <Button onClick={goToContactUs} icon={<ArrowForward />} type='darkTertiary'>
                    Contact Us
                </Button>
                <Accordion items={faqItems} />
            </div>
        </div>
    );
}

export default ProductsPage;

